import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { H2 } from '../typography'
import './style.css'

class ProjectsPrint extends PureComponent {
  static propTypes = {
    project: PropTypes.shape({
      gallery: PropTypes.arrayOf(PropTypes.shape({})),
      tags: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
      slug: PropTypes.string,
      id: PropTypes.string
    })
  }

  render () {
    const { project } = this.props

    return (
      <div className='project-slider__print'>
        <img src={project.gallery[0].sm} alt='print' />
        <div
          className='project-slide'
          data-history={project.slug}
          key={project.slug}
        >
          <div className='projects-print_project-card'>
            <div key={project.id} className='card__content'>
              <div className='projects_project-card__content-details'>
                <div className='header'>
                  <div className='year'>&#8216;{project.year && String(project.year).slice(-2)}</div>
                  <H2 className='name'>{project.name || ''}</H2>
                </div>
                <div className='tags'>{project && project.tags && project.tags.map(tag => (<div key={tag}>{tag}</div>))}</div>
                <div className='description'>{project.description}</div>
              </div>
              <div className='btn-links'>
                <div className='public-link__block'>
                  {
                    project.publicLinks
                      ? project.publicLinks.map(({ linkName }, i) => (<div key={i}>{linkName}</div>))
                      : ''
                  }
                </div>
              </div>
              <div className='services'>
                <div className='services-title'>Services</div>
                <div className='services-content'>
                  {project && project.services && project.services.map(s => (<div className='services-content__item' key={s}>{s}</div>))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectsPrint
